/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { STORE, MYPROJECTS, MYACTIVITY, MYPAYMENTS, RESET } from './mutation-types';

export default {
  [STORE](state, account) {
    state.email = account.email;
    state.firstName = account.firstName;
    state.lastName = account.lastName;
  },

  [MYPROJECTS](state, payload) {
    state.myProjects = payload;
  },

  [MYACTIVITY](state, payload) {
    state.myActivity = payload;
  },

  [MYPAYMENTS](state, payload) {
    state.myPayments = payload;
  },

  [RESET](state) {
    state.email = null;
    state.firstName = null;
    state.lastName = null;
    state.myProjects = [];
    state.myActivity = [];
    state.myPayments = [];
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/account/mutations.js